<template>
  <div>
    <span style="padding: 5px 0;">注意上传对应单位退保证金资料信息，同一条退保记录只能上传一份文件，多份文件请打包压缩上传</span>
    <Table
      :columns="columns"
      :data="flowMargin"
    ></Table>
    <!-- 流程分支 -->
    <flowBranch
      :visible="branchVisible"
      :branchList="flowBranch"
      @visibleChange="visibleChange"
      @branchChoose="branchChoose"
      :transfer="false"
    ></flowBranch>
    <!-- 流程人员选择 -->
    <Modal
      v-model="peopleSelectVisible"
      class="flow-modal"
      width="700px"
      title="流程人员选择"
      :transfer="false"
    >
      <flowNext
        :child-msg="flowPeople"
        @toparentevent="handlePeopleSelect"
      ></flowNext>
      <div slot="footer">
        <Button @click="peopleSelectVisible=false">取消</Button>
        <Button
          @click="startFlow"
          type="primary"
        >确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { fileUtil } from '@/lib/abpfile'
import { Upload, Button } from 'iview'
import axios from 'axios'
import FlowBranch from '@/components/flow/flowBranch'
import FlowNext from '@/components/flow/flowNext'
import { startWorkflow, getActivityUsers } from '@/lib/flow'
import { guid, formatDate } from '@/lib/tool'
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'
import UploadBtn from '@/components/uploadBtn'

// 上传文件类型
const fileType = 1
// 流程应用Id
const flowType = 'RM'

export default {
  name: 'depositFlowStart',
  components: {
    Upload,
    Button,
    FlowNext,
    FlowBranch,
    UploadBtn
  },
  props: {
    flowMargin: {
      type: Array,
      default() {
        return []
      }
    },
    uploadFileInit: {
      type: Object,
      default() {
        return {
          action: '',
          extradata: {}
        }
      }
    }
  },
  data() {
    return {
      columns: [
        {
          title: '汇款单位',
          render: (h, params) => {
            return h('div', params.row.abpOrdersExp.bankName)
          }
        },
        {
          title: '报名供应商',
          key: 'ghfCompanyName'
        },
        {
          title: '包组',
          width: 65,
          render: (h, params) => {
            return h('div', params.row.abpOrdersExp.clGroupDb.groupNo)
          }
        },
        {
          title: '金额',
          key: 'orderAmountTotal',
          width: 80
        },
        {
          title: '文件上传',
          width: 85,
          render: (h, params) => {
            return (
              <UploadBtn mark={params.row} on-beforeUpload={this.uploadTrigger} on-fileSelected={this.handleBeforeUpload}></UploadBtn>
            )
          }
        },
        {
          title: '文件名',
          render: (h, params) => {
            let fileName = '未上传'
            if (params.row.dbFile && params.row.dbFile.fileName) {
              fileName = params.row.dbFile.fileName
            }
            return h('div', fileName)
          }
        },
        {
          title: '备注',
          render: (h, params) => {
            return h('input', {
              domProps: {
                value: this.flowMarginCopy[params.index].comment,
              },
              on: {
                input: (event) => {
                  this.flowMarginCopy[params.index].comment = event.target.value
                  this.flowMargin[params.index].comment = event.target.value
                }
              },
              style: {
                width: '100%',
                border: '1px solid #ddd'
              }
            })
          }
        }
      ],
      uploadMargin: {},
      flowMarginCopy: [],
      flowBranch: [],
      branchVisible: false,
      flowPeople: {},
      peopleSelectVisible: false,
      selectedPeople: ''
    }
  },
  computed: {
    userPhone() {
      return this.$store.state.session.user.phoneNumber
    },
    user() {
      return this.$store.state.session.user
    }
  },
  methods: {
    uploadTrigger(row) {
      this.uploadMargin = row
    },
    async handleBeforeUpload(file) {
      let suffix = fileUtil.get_suffix(file.name)
      this.uploadFileInit.extradata.key = this.uploadFileInit.extradata.key + fileUtil.random_string(10) + suffix
      this.uploadFileInit.extradata['x:displayname'] = file.name
      this.uploadFileInit.extradata['x:objectid'] = this.uploadMargin.id
      this.uploadFileInit.extradata['x:objectidtype'] = '退保证金资料'
      // handleSuccess 监听不了
      this.$Spin.show()
      try {
        let uploadData = new FormData()
        for (let key in this.uploadFileInit.extradata) {
          uploadData.append(key, this.uploadFileInit.extradata[key])
        }
        uploadData.append('file', file)
        let rep = await axios.post(this.uploadFileInit.action, uploadData)
        this.$Spin.hide()
        if (rep.data.success) {
          let dbFile = {
            "id": "",
            "usage": fileType,
            "ossId": rep.data.result.id,
            "fileName": rep.data.result.displayName,
            "keyValue": this.uploadMargin.projectId,
            "objectId": this.uploadMargin.id,
            "fileType": "退保证金资料", // 类型
          }
          for (let i = 0; i < this.flowMarginCopy.length; i++) {
            if (this.flowMarginCopy[i].id === this.uploadMargin.id) {
              this.$set(this.flowMargin[i], 'dbFile', dbFile)
              this.$set(this.flowMarginCopy[i], 'dbFile', dbFile)
              break
            }
          }
        } else {
          this.$Message.error('上传失败')
        }
      } catch (err) {
        console.error(err)
        this.$Spin.hide()
        this.$Message.error('上传失败')
      }
    },
    async getFlowUser() {
      // 获取流程人员
      this.$Spin.show()
      try {
        let rep = await getActivityUsers({ appId: flowType, userPhone: this.userPhone })
        this.$Spin.hide()
        this.flowBranch = rep
        this.branchVisible = true
      } catch (err) {
        this.$Spin.hide()
        console.error(err)
        this.$Message.error('获取流程人员失败')
      }
    },
    async startFlow() {
      if (this.selectedPeople === '') {
        this.$Message.error('请先选择流程人员')
        return
      }
      let workFlowId = guid()
      let flowInfo = {
        area: this.flowMarginCopy[0].clProjectDb.district,
        company: this.flowMarginCopy[0].clProjectDb.companyName,
        title: `退保证金-${this.flowMarginCopy[0].projectFull}`,
        time: formatDate()
      }
      let thisUser = {
        appId: flowType,
        userPhone: this.userPhone,
        wiid: workFlowId,
        flowTitle: `退保证金-${this.flowMarginCopy[0].projectFull}`,
        businessKey: JSON.stringify(flowInfo)
      }
      let nextUser = {
        nextActivityCode: this.flowPeople.NextActivityCode,
        userId: this.selectedPeople.userId
      }
      this.$Spin.show()
      try {
        // 流程发起
        let startFlowRep = await startWorkflow(thisUser, nextUser)

        // 流程信息
        let flowLogList = []
        // 订单流程状态
        let orderFlowList = []

        this.flowMarginCopy.forEach(flowMargin => {

          const contentJson = {
            isBidding: flowMargin.isBidding, // 是否中标
            creator: this.user.name, // 发起人
            groupNo: flowMargin.abpOrdersExp.clGroupDb.groupNo, // 包组号
            amount: flowMargin.orderAmountTotal, // 金额
            enrollCompany: flowMargin.ghfCompanyName, // 报名单位
            remittanceCompany: flowMargin.abpOrdersExp.bankName, // 保证金汇款单位
            orderNo: flowMargin.orderNo
          }

          let flowLog = {
            abpFlowLog: {
              id: '',
              ordersId: flowMargin.id,
              workFlowId: workFlowId,
              fileId: flowMargin.dbFile ? flowMargin.dbFile.ossId : '',
              comment: flowMargin.comment,
              contentJson: JSON.stringify(contentJson),
              fileName: flowMargin.dbFile ? flowMargin.dbFile.fileName : '',
              flowType: '退保证金',
              projectId: flowMargin.projectId
            }
          }
          flowLogList.push(flowLog)
          let orderFlow = {
            ordersId: flowMargin.id,
            flowStatus: '1'
          }
          orderFlowList.push(orderFlow)
        })

        // 记录流程附带信息
        await ajax.post(requestUrls.AbpFlowLog.CreateOrUpdateList, flowLogList)

        // 修改订单状态
        await ajax.post(requestUrls.order.SetOrdersFlowStatus, orderFlowList)

        this.$Spin.hide()

        this.peopleSelectVisible = false
        this.$emit('flowStartFinish')

        this.$Message.success('流程发起成功')

      } catch(err) {
        console.error(err)
        this.$Spin.hide()
        this.$Message.error('操作失败')
      }
    },
    branchChoose(val) {
      this.branchVisible = false
      this.flowPeople = val
      this.peopleSelectVisible = true
    },
    visibleChange(val) {
      this.branchVisible = val
    },
    handlePeopleSelect(selectedPeople) {
      this.selectedPeople = selectedPeople
    },
  },
  watch: {
    flowMargin: {
      handler(val) {
        this.flowMarginCopy = JSON.parse(JSON.stringify(val))
      },
      immediate: true
    }
  }
}
</script>

<style lang="less" scoped>
</style>
